var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"md":"12"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }